import * as actionTypes from './actionTypes';

interface State {
  title: string;
  positionOf: Array<number>;
}

const initialState: State = {
  title: '',
  positionOf: []
}

export const breadCrumb = (state = initialState, action) => {
  switch(action.type) {
    case actionTypes.SET_TITLE_BREADCRUMB:
      return {
        title: action.title
      };
    case actionTypes.SET_POSITIONOF_BREADCRUMB:
      return {
        positionOf: action.positionOf
      };
    default:
      return state;
  }
}
